import React from "react";

/**
 * StatGrid — responsive auto-fill grid wrapper for StatCard components.
 */
const StatGrid = ({ children }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
      gap: 10,
      marginBottom: "1.5rem",
    }}
  >
    {children}
  </div>
);

export default StatGrid;
